// src/scenes/groupPositions/form.jsx

import React, { useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from "@mui/material";

const GroupPositionForm = ({ open, onClose, formData, setFormData, onSubmit }) => {
  useEffect(() => {
    if (!open) {
      setFormData({ positionName: "", description: "" });
    }
  }, [open, setFormData]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Create Group Position</DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          label="Position Name"
          margin="dense"
          value={formData.positionName}
          onChange={(e) => setFormData({ ...formData, positionName: e.target.value })}
        />
        <TextField
          fullWidth
          label="Description"
          margin="dense"
          multiline
          rows={3}
          value={formData.description}
          onChange={(e) => setFormData({ ...formData, description: e.target.value })}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={onSubmit}>Create</Button>
      </DialogActions>
    </Dialog>
  );
};

export default GroupPositionForm;
